import { POST_USER_TEST_ASSIGNMENTS_SUCCESS } from 'stash/actions/api/application';
import { TEST_ASSIGNMENT_TYPES, TEST_NAMES } from 'stash/constants/testAssignmentTypes';

const initialState = {
	[TEST_NAMES.SKIP_PLASTIC]: TEST_ASSIGNMENT_TYPES.CONTROL,
};

const testAssignment = (state = initialState, action) => {
	switch (action.type) {
		case POST_USER_TEST_ASSIGNMENTS_SUCCESS:
			let { assignmentName } = action.response.userTestAssignment;
			let { testName } = action.request.body.userTestAssignment;
			return {
				...state,
				[testName]: assignmentName || TEST_ASSIGNMENT_TYPES.CONTROL,
			};
		default:
			return state;
	}
};

export default testAssignment;
